import {
  DBDrawerCloseButton,
  DBDrawerHeader,
  ProviderImageContainer,
  ProviderInfoContainer
} from 'Src/shared/direct-book-drawer/styles';
import Cancel from '@kyruus/react-ikons/Cancel';
import React from 'react';
import {
  getProviderDisplayName,
  getProviderImageUrl
} from '@kyruus/provider-components';

const getProviderSpecialties = (provider) => {
  return provider.specialties
    .filter((specialty) => !!specialty.name)
    .map((specialty) => specialty.name)
    .join(', ');
};

export const DirectBookWidgetHeaderWithProviderDetails = ({
  provider,
  handleClose,
  closeButtonSize,
  closeButtonColor
}) => {
  const specialty = provider ? getProviderSpecialties(provider) : '';
  // Use getProviderDisplayName for consistent name formatting across the app
  const name = provider ? getProviderDisplayName(provider) : '';
  // Use getProviderImageUrl for proper image URL handling
  const imageUrl = provider ? getProviderImageUrl(provider) : '';

  return (
    <DBDrawerHeader data-testid="direct-book-drawer-header">
      <ProviderImageContainer
        alt={name}
        id={`direct-book-drawer-image-${name}`}
        src={imageUrl}
        itemProp="image"
      />
      <ProviderInfoContainer>
        <span>{name}</span>
        <span>{specialty}</span>
      </ProviderInfoContainer>
      <DBDrawerCloseButton
        data-testid="db_drawer_close_button"
        mode="flat"
        onClick={handleClose}
      >
        <Cancel size={closeButtonSize} color={closeButtonColor} />
      </DBDrawerCloseButton>
    </DBDrawerHeader>
  );
};
